export var LocaleContext;
(function (LocaleContext) {
    LocaleContext["Callout"] = "callout";
    LocaleContext["System"] = "system";
})(LocaleContext || (LocaleContext = {}));
//# sourceMappingURL=locale-context.js.map